import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    call: {
      phone:'',
      victim: {
        name: '',
        age: '',
        genre: '',
      },
      reason: '',
      type: '',
    },
    callSelected: undefined
  },
  mutations: {
    setSolicitationInfoCall(state, payload) {
      state.call = {...state.call,...payload}
    },
    setCallSelected (state, payload){
      state.callSelected = payload;
    },
    setVictimsInfoCall(state, payload) {
      state.call.victims = payload;
    },
  },
  actions: {

    setSolicitationInfoCall ({commit},payload) {
      commit('setSolicitationInfoCall',payload)
    },

    setVictimsInfoCall ({commit},payload) {
      commit('setVictimsInfoCall',payload)
    },

    async removeEmergency ({rootState}, payload) {

      
      console.log('item sendo deletado',payload,rootState.User.userToken);
      let route = rootState.User.userRule.includes('admin') ? 'administrators' : 'employees';
      route= 'regulatory-physician';
      let id = payload.id;
      delete payload.id
      let headerConfig = {
        headers: {
            Authorization: `bearer ${rootState.User.userToken}`
        },
        data: payload
      }
      return await this.$http.delete(`/api/${route}/attendances/${id}`, headerConfig)
        .then( response => {
            return response;
        })
        .catch( error => {
            return error;
        });  
    },

    async editTarm({ rootState }, payload) {

      let headerConfig = {
          headers: {
              Authorization: `bearer ${rootState.User.userToken}`
          }
      }
      let route = rootState.User.userRule.includes('admin') ? 'administrators' : 'employees';
      route= 'regulatory-physician'
      return await this.$http.put(`/api/${route}/attendances/${payload.id}`,payload, headerConfig)
          .then( response => {
              return response;
          })
          .catch( error => {
              return error;
          });
  },

  },
  getters: {

    call(state) {
      return state.call;
    },

    callSelected (state){
      return state.callSelected;
    }
  }
};